import { authHeader, authHeaderUpload, handleResponse } from '@/api/handler/main';

export const managerFormService = {
    getListManagerForm,
    getDetailManagerForm,
    registerManagerForm,
    updateManagerForm,
    deleteManagerForm,
    syncFormPublish,
    settingPublishTime,
    stopPublishNow,
    getAnalytics,
    getRegisterEmailsAnalytics,
    updateAnalytics,
    deleteAnalytics,
    getListBlockOriginalOfForm,
    getListBlockOfForm,
    getListBlockOfFormSerial,
    getListOptionOfBlock,
    exportDataBlockForm,
    getListTemplateManagerForm,
    registerTemplateManagerForm,
    getDetailTemplateManagerForm,
    formSettingEmail,
    getDetailSettingEmail,
    copyFormApi,
    getListDomainEmail,
    registerDomainEmail,
    updateDomainEmail,
    deleteDomainEmail,
    getListCustomDomain,
    registerCustomDomain,
    updateCustomDomain,
    deleteCustomDomain,
    getListEmailSender,
    registerEmailSender,
    updateEmailSender,
    deleteEmailSender,
    getListEmailReply,
    getListAllEmailReply,
    getListAllEmailFrom,
    registerEmailReply,
    updateEmailReply,
    deleteEmailReply,
    deleteFormAndData,
    deleteAllResultAnalytics,
    deletePermanentlyResultAnalytics,
    deletePermanently,
    sendMailTest,
    registerTemplateMail,
    getListAllTemplateMail,
    exportDataRegisterEmail,
    updateTemplateMail,
    deleteTemplateMail,
    importSerialCode,
    downloadSerialCode,
    importProductForPrize,
    downloadProductForPrize,
    autoGenSerialCode,
    getDailyLimitsPrizeForm,
    getAnalyticsLottery,
    downloadLotteryHistory,
    downloadSerialCodes,
    getListSerialCode,
    getListSerialCodeAnalytics,
    createSerialCode,
    updateSerialCode,
    deleteSerialCode,
    downloadListSerialCode,
    jobCheckImportSerial,
    jobCheckAutoGenSerial,
    jobDeleteListSerial,
    jobDeleteS3AnalyticsStatus,
    checkStatusCopySerial
};

function getListManagerForm(query) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms?${query}`, requestOptions).then(handleResponse);
}

function getAnalytics(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/results?${payload.query}`, requestOptions).then(handleResponse);
}
function getRegisterEmailsAnalytics(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/registered-emails?${payload.query}`, requestOptions).then(
        handleResponse
    );
}

function getListBlockOriginalOfForm(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${id}/list-blocks-original`, requestOptions).then(handleResponse);
}

function getListBlockOfForm(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    const id = typeof payload === 'object' ? payload.id : payload;
    const query = typeof payload === 'object' && payload.query ? `?${payload.query}` : '';
    return fetch(process.env.VUE_APP_APIURL + `/forms/${id}/list-blocks${query}`, requestOptions).then(handleResponse);
}
function getListBlockOfFormSerial(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${id}/list-blocks-for-serial-code`, requestOptions).then(handleResponse);
}
function getListOptionOfBlock(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/block/${payload.idBlock}/list-options`, requestOptions).then(handleResponse);
}
function updateAnalytics(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/results/${payload.idBlock}`, requestOptions).then(handleResponse);
}
function deleteAnalytics(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/results/${payload.idBlock}`, requestOptions).then(handleResponse);
}

function getDetailManagerForm(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${id}`, requestOptions).then(handleResponse);
}

function registerManagerForm(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms`, requestOptions).then(handleResponse);
}

function updateManagerForm(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}`, requestOptions).then(handleResponse);
}

function deleteManagerForm(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}`, requestOptions).then(handleResponse);
}

function syncFormPublish(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: ''
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload?.id}/sync-publish-data`, requestOptions).then(handleResponse);
}

function settingPublishTime(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/setting-publish-time`, requestOptions).then(handleResponse);
}

function stopPublishNow(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: ''
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/stop-publish-now`, requestOptions).then(handleResponse);
}

function exportDataBlockForm(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload.body)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/download/${payload.body.form_id}/form-data${payload.param}`, requestOptions).then(
        handleResponse
    );
}
function exportDataRegisterEmail(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload.body)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/download/registered-emails${payload.param}`, requestOptions).then(handleResponse);
}

function getListTemplateManagerForm() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/template/get-all`, requestOptions).then(handleResponse);
}

function registerTemplateManagerForm(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/template`, requestOptions).then(handleResponse);
}

function getDetailTemplateManagerForm(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/template/${id}`, requestOptions).then(handleResponse);
}

function formSettingEmail(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/email-setting`, requestOptions).then(handleResponse);
}
function getDetailSettingEmail(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/email-setting/${id}`, requestOptions).then(handleResponse);
}

function copyFormApi(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/copy`, requestOptions).then(handleResponse);
}

function getListDomainEmail(query) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/domain?${query}`, requestOptions).then(handleResponse);
}

function registerDomainEmail(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/domain`, requestOptions).then(handleResponse);
}

function updateDomainEmail(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/domain/${payload.id}`, requestOptions).then(handleResponse);
}

function deleteDomainEmail(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/domain/${id}`, requestOptions).then(handleResponse);
}

function getListCustomDomain(query) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/custom-domains?${query}`, requestOptions).then(handleResponse);
}

function registerCustomDomain(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeaderUpload(),
        body: payload
    };
    return fetch(process.env.VUE_APP_APIURL + `/custom-domains`, requestOptions).then(handleResponse);
}

function updateCustomDomain(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeaderUpload(),
        body: payload.data
    };
    return fetch(process.env.VUE_APP_APIURL + `/custom-domains/${payload.id}`, requestOptions).then(handleResponse);
}

function deleteCustomDomain(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/custom-domains/${id}`, requestOptions).then(handleResponse);
}

function getListEmailSender() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/sender`, requestOptions).then(handleResponse);
}

function registerEmailSender(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/sender`, requestOptions).then(handleResponse);
}

function updateEmailSender(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/sender/${payload.id}`, requestOptions).then(handleResponse);
}

function deleteEmailSender(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/sender/${id}`, requestOptions).then(handleResponse);
}

function getListEmailReply() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/reply`, requestOptions).then(handleResponse);
}
function getListAllEmailReply() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/reply/all`, requestOptions).then(handleResponse);
}
function getListAllEmailFrom() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/sender/all`, requestOptions).then(handleResponse);
}
function getListAllTemplateMail() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/mail-templates/get-all`, requestOptions).then(handleResponse);
}
function updateTemplateMail(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/mail-templates/${payload.id}`, requestOptions).then(handleResponse);
}
function deleteTemplateMail(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/mail-templates/${id}`, requestOptions).then(handleResponse);
}

function registerEmailReply(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/reply`, requestOptions).then(handleResponse);
}

function updateEmailReply(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/reply/${payload.id}`, requestOptions).then(handleResponse);
}

function deleteEmailReply(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/email-setting/email/reply/${id}`, requestOptions).then(handleResponse);
}

function deleteFormAndData(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/delete-form-and-all-results`, requestOptions).then(handleResponse);
}

function deleteAllResultAnalytics(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/delete-all-results`, requestOptions).then(handleResponse);
}

function deletePermanentlyResultAnalytics(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/permanently/delete-all-results`, requestOptions).then(handleResponse);
}

function deletePermanently(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/delete-permanently`, requestOptions).then(handleResponse);
}
function sendMailTest(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/mail-templates/send-test-mail`, requestOptions).then(handleResponse);
}
function registerTemplateMail(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/mail-templates`, requestOptions).then(handleResponse);
}

function importSerialCode(payload) {
    return fetch(`${process.env.VUE_APP_APIURL}/forms/${payload.formId}/serial-codes/import`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + window.$cookies.get('token')
        },
        body: payload.formData
    }).then(handleResponse);
}
function downloadSerialCode(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/download`, requestOptions).then(handleResponse);
}

function importProductForPrize(payload) {
    return fetch(`${process.env.VUE_APP_APIURL}/forms/${payload.formId}/prizes/import-product`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + window.$cookies.get('token')
        },
        body: payload.formData
    }).then(handleResponse);
}

function downloadProductForPrize(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/prizes/download-product`, requestOptions).then(handleResponse);
}

function autoGenSerialCode(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/generate`, requestOptions).then(handleResponse);
}

function getDailyLimitsPrizeForm(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/prizes/${payload.prize_id}/daily-limits`, requestOptions).then(
        handleResponse
    );
}

function getAnalyticsLottery(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/lottery-history?${payload.query}`, requestOptions).then(handleResponse);
}

function downloadLotteryHistory(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload.body)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/download/lottery-history${payload.param}`, requestOptions).then(
        handleResponse
    );
}

function downloadSerialCodes(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.id}/analytics/serial-codes/download${payload.param}`, requestOptions).then(
        handleResponse
    );
}

function getListSerialCode(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes${payload.query}`, requestOptions).then(handleResponse);
}

function getListSerialCodeAnalytics(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/analytics/serial-codes${payload.query}`, requestOptions).then(
        handleResponse
    );
}

function createSerialCode(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes`, requestOptions).then(handleResponse);
}

function updateSerialCode(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload.data)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/${payload.serial_id}`, requestOptions).then(handleResponse);
}

function deleteSerialCode(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes`, requestOptions).then(handleResponse);
}

function downloadListSerialCode(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/download`, requestOptions).then(handleResponse);
}

function jobCheckImportSerial(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(
        process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/import-status?batch_id=${payload.batch_id}`,
        requestOptions
    ).then(handleResponse);
}

function jobCheckAutoGenSerial(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(
        process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/generation-status?batch_id=${payload.batch_id}`,
        requestOptions
    ).then(handleResponse);
}

function jobDeleteListSerial(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(
        process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/delete-status?batch_id=${payload.batch_id}`,
        requestOptions
    ).then(handleResponse);
}

function checkStatusCopySerial(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/serial-codes/copy-status`, requestOptions).then(handleResponse);
}

function jobDeleteS3AnalyticsStatus(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_APIURL + `/forms/${payload.form_id}/analytics/s3-job-status?batch_id=${payload.batch_id}`, requestOptions).then(
        handleResponse
    );
}
